export default __webpack_public_path__ + "static/media/logo.cf8d46c1.svg";